import React, { useState, useEffect } from "react";
import axios from "axios";
import { Formik } from "formik";
import * as Yup from "yup";
import { Col, Row, Label, Input, Form } from "reactstrap";
import { UserConsumer } from "../../../UserContext";
import { AlertPopups } from "../../../components/AlertPopups";
import "./SpResourceLeavesInfo.scss";
import { Redirect, useHistory, useParams } from "react-router-dom";
import { ResourceLeavesInfo_API } from "./ResourceLeavesInfo_API";
import Header from "../../../components/Header";

function AdminViewResourceLeavesInfo() {
	let token,
		empId = null;
	const { id } = useParams();
	const history = useHistory();
	const [apiHeaderToken, setApiHeaderToken] = useState(null);
	const [resLeavesInfoData, setResLeavesInfoData] = useState({
		empID: "",
		employeeName: "",
		employeeCode: "",
		employeeDepartment: "",
		totalSickLeave: "",
		compansationLeave: "",
		totalCompansationLeave: "",
		annualLeave: "",
		totalAnnualLeave: "",
		withoutPayLeave: "",
		totalWithoutPayLeave: "",
		maternityLeave: "",
		totalMaternityLeave: "",
		otherLeave: "",
	});

	const validate = Yup.object().shape({
		sickLeave: Yup.string().required("Required").nullable(),
		totalSickLeave: Yup.string().required("Required").nullable(),
		compansationLeave: Yup.string().required("Required").nullable(),
		totalCompansationLeave: Yup.string().required("Required").nullable(),
		annualLeave: Yup.string().required("Required").nullable(),
		totalAnnualLeave: Yup.string().required("Required").nullable(),
		withoutPayLeave: Yup.string().required("Required").nullable(),
		totalWithoutPayLeave: Yup.string().required("Required").nullable(),
		maternityLeave: Yup.string().required("Required").nullable(),
		totalMaternityLeave: Yup.string().required("Required").nullable(),
		otherLeave: Yup.string().required("Required").nullable(),
	});

	useEffect(() => {
		const header = { Authorization: `Bearer ${token}` };
		if (id) {
			//get resource info
			axios
				.get(
					`${ResourceLeavesInfo_API.GetResourceLeavesInfoById}/${id}`,
					{
						headers: header,
					}
				)
				.then(({ status, data }) => {
					if (status === 200) {
						setResLeavesInfoData(data);
					}
				});
		}
		setApiHeaderToken(header);
	}, []);

	const handleSubmit = () => {
		const empId = resLeavesInfoData.employeeID;
		axios
			.put(
				`${ResourceLeavesInfo_API.PUTResourceLeaveInfo}/${empId}`,
				resLeavesInfoData,
				{
					headers: apiHeaderToken,
				}
			)
			.then(({ status, message }) => {
				if (status === 200) {
					AlertPopups.successAlert.fire({
						text: "Updated",
					});
					history.push("ViewEmployees");
				} else if (status === 400) {
					AlertPopups.ErrorAlert.fire({
						text: message,
					});
				}
			})
			.catch((error) => {
				if (error.response)
					AlertPopups.ErrorAlert.fire({
						text: error.response.data.message,
					});
			});
	};

	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				empId = userDetails.id;
				return userDetails.empRole.includes("3") || empId === "33" ? (
					<>
						<div className="container-fluid pl-3 pr-3">
							<Header
								title="Employees Leaves Info"
								headerBorder="false"
								navigateBack={() =>
									history.push("/ViewEmployees")
								}
							/>

							<Formik
								enableReinitialize={true}
								initialValues={resLeavesInfoData}
								validationSchema={validate}
								validateOnChange={true}
								onSubmit={() => {
									handleSubmit();
								}}
							>
								{({ errors, handleSubmit }) => (
									<Form>
										<div className="mt-3 formInfoContainer">
											<div className="formInfoContainerHeader">
												<Label sm={12}>
													Personal Information
												</Label>
											</div>
											<Row className="py-2 px-4">
												<Col md={12} lg={2}>
													<div className="formDetailHeader">
														<div>Employee Name</div>
													</div>
												</Col>
												<Col md={12} lg={4}>
													<p className="formValueContainer">
														{
															resLeavesInfoData.employeeName
														}
													</p>
												</Col>
												<Col md={12} lg={2}>
													<div className="formDetailHeader">
														<div>Employee Code</div>
													</div>
												</Col>
												<Col md={12} lg={4}>
													<p className="formValueContainer">
														{
															resLeavesInfoData.employeeCode
														}
													</p>
												</Col>
												<Col md={12} lg={2}>
													<div className="formDetailHeader">
														<div>Department</div>
													</div>
												</Col>
												<Col md={12} lg={4}>
													<p className="formValueContainer">
														{
															resLeavesInfoData.employeeDepartment
														}
													</p>
												</Col>
												<Col md={12} lg={2}>
													<div className="formDetailHeader">
														<div>Others</div>
													</div>
												</Col>
												<Col md={12} lg={4}>
													<Input
														type="number"
														value={
															resLeavesInfoData.otherLeave
														}
														onChange={(event) => {
															empId === "33" &&
																setResLeavesInfoData(
																	{
																		...resLeavesInfoData,
																		["otherLeave"]:
																			event
																				.target
																				.value,
																	}
																);
														}}
														className={`formValueInput ${
															errors.otherLeave
																? "h-auto invalid"
																: "h-auto"
														}`}
													/>
												</Col>
												<Col md={12} lg={2}>
													<div className="formDetailHeader">
														<div>
															Remaining Sick
														</div>
													</div>
												</Col>
												<Col md={12} lg={4}>
													<Input
														type="number"
														value={
															resLeavesInfoData.sickLeave
														}
														onChange={(event) => {
															empId === "33" &&
																setResLeavesInfoData(
																	{
																		...resLeavesInfoData,
																		["sickLeave"]:
																			event
																				.target
																				.value,
																	}
																);
														}}
														className={`formValueInput ${
															errors.sickLeave
																? "h-auto invalid"
																: "h-auto"
														}`}
													/>
												</Col>
												<Col md={12} lg={2}>
													<div className="formDetailHeader">
														<div>Total Sick</div>
													</div>
												</Col>
												<Col md={12} lg={4}>
													<Input
														type="number"
														value={
															resLeavesInfoData.totalSickLeave
														}
														onChange={(event) => {
															empId === "33" &&
																setResLeavesInfoData(
																	{
																		...resLeavesInfoData,
																		["totalSickLeave"]:
																			event
																				.target
																				.value,
																	}
																);
														}}
														className={`formValueInput ${
															errors.totalSickLeave
																? "h-auto invalid"
																: "h-auto"
														}`}
													/>
												</Col>
												<Col md={12} lg={2}>
													<div className="formDetailHeader">
														<div>
															Remaining Annual
														</div>
													</div>
												</Col>
												<Col md={12} lg={4}>
													<Input
														type="number"
														value={
															resLeavesInfoData.annualLeave
														}
														onChange={(event) => {
															empId === "33" &&
																setResLeavesInfoData(
																	{
																		...resLeavesInfoData,
																		["annualLeave"]:
																			event
																				.target
																				.value,
																	}
																);
														}}
														className={`formValueInput ${
															errors.annualLeave
																? "h-auto invalid"
																: "h-auto"
														}`}
													/>
												</Col>
												<Col md={12} lg={2}>
													<div className="formDetailHeader">
														<div>Total Annual</div>
													</div>
												</Col>
												<Col md={12} lg={4}>
													<Input
														type="number"
														value={
															resLeavesInfoData.totalAnnualLeave
														}
														onChange={(event) => {
															empId === "33" &&
																setResLeavesInfoData(
																	{
																		...resLeavesInfoData,
																		["totalAnnualLeave"]:
																			event
																				.target
																				.value,
																	}
																);
														}}
														className={`formValueInput ${
															errors.totalAnnualLeave
																? "h-auto invalid"
																: "h-auto"
														}`}
													/>
												</Col>
												<Col md={12} lg={2}>
													<div className="formDetailHeader">
														<div>
															Remaining
															Compensation
														</div>
													</div>
												</Col>
												<Col md={12} lg={4}>
													<Input
														type="number"
														value={
															resLeavesInfoData.compansationLeave
														}
														onChange={(event) => {
															empId === "33" &&
																setResLeavesInfoData(
																	{
																		...resLeavesInfoData,
																		["compansationLeave"]:
																			event
																				.target
																				.value,
																	}
																);
														}}
														className={`formValueInput ${
															errors.compansationLeave
																? "h-auto invalid"
																: "h-auto"
														}`}
													/>
												</Col>
												<Col md={12} lg={2}>
													<div className="formDetailHeader">
														<div>
															Total Compensation
														</div>
													</div>
												</Col>
												<Col md={12} lg={4}>
													<Input
														type="number"
														value={
															resLeavesInfoData.totalCompansationLeave
														}
														onChange={(event) => {
															empId === "33" &&
																setResLeavesInfoData(
																	{
																		...resLeavesInfoData,
																		["totalCompansationLeave"]:
																			event
																				.target
																				.value,
																	}
																);
														}}
														className={`formValueInput ${
															errors.totalCompansationLeave
																? "h-auto invalid"
																: "h-auto"
														}`}
													/>
												</Col>
												<Col md={12} lg={2}>
													<div className="formDetailHeader">
														<div>
															Remaining Maternity
														</div>
													</div>
												</Col>
												<Col md={12} lg={4}>
													<Input
														type="number"
														value={
															resLeavesInfoData.maternityLeave
														}
														onChange={(event) => {
															empId === "33" &&
																setResLeavesInfoData(
																	{
																		...resLeavesInfoData,
																		["maternityLeave"]:
																			event
																				.target
																				.value,
																	}
																);
														}}
														className={`formValueInput ${
															errors.maternityLeave
																? "h-auto invalid"
																: "h-auto"
														}`}
													/>
												</Col>
												<Col md={12} lg={2}>
													<div className="formDetailHeader">
														<div>
															Total Maternity
														</div>
													</div>
												</Col>
												<Col md={12} lg={4}>
													<Input
														type="number"
														value={
															resLeavesInfoData.totalMaternityLeave
														}
														onChange={(event) => {
															empId === "33" &&
																setResLeavesInfoData(
																	{
																		...resLeavesInfoData,
																		["totalMaternityLeave"]:
																			event
																				.target
																				.value,
																	}
																);
														}}
														className={`formValueInput ${
															errors.totalMaternityLeave
																? "h-auto invalid"
																: "h-auto"
														}`}
													/>
												</Col>
												<Col md={12} lg={2}>
													<div className="formDetailHeader">
														<div>
															Remaining Without
															Pay
														</div>
													</div>
												</Col>
												<Col md={12} lg={4}>
													<Input
														type="number"
														value={
															resLeavesInfoData.withoutPayLeave
														}
														onChange={(event) => {
															empId === "33" &&
																setResLeavesInfoData(
																	{
																		...resLeavesInfoData,
																		["withoutPayLeave"]:
																			event
																				.target
																				.value,
																	}
																);
														}}
														className={`formValueInput ${
															errors.withoutPayLeave
																? "h-auto invalid"
																: "h-auto"
														}`}
													/>
												</Col>
												<Col md={12} lg={2}>
													<div className="formDetailHeader">
														<div>
															Total Without Pay
														</div>
													</div>
												</Col>
												<Col md={12} lg={4}>
													<Input
														type="number"
														value={
															resLeavesInfoData.totalWithoutPayLeave
														}
														onChange={(event) => {
															empId === "33" &&
																setResLeavesInfoData(
																	{
																		...resLeavesInfoData,
																		["totalWithoutPayLeave"]:
																			event
																				.target
																				.value,
																	}
																);
														}}
														className={`formValueInput ${
															errors.totalWithoutPayLeave
																? "h-auto invalid"
																: "h-auto"
														}`}
													/>
												</Col>
											</Row>
										</div>
										{empId === "33" && (
											<Row className="extractDetail-form-btns">
												<Col className="p-0">
													<input
														type="submit"
														value="Update"
														className="submit-btn"
														onClick={handleSubmit}
													/>
												</Col>
											</Row>
										)}
									</Form>
								)}
							</Formik>
						</div>
					</>
				) : (
					<Redirect to="/MyDashboard" />
				);
			}}
		</UserConsumer>
	);
}

export default AdminViewResourceLeavesInfo;
